import {ValueObject} from '@s-ui/domain'

import {DealerProfileRatingsValueObject} from '../../ratings/ValueObjects/DealerProfileRatingsValueObject.js'
import {PackSellerValueObject} from './PackSellerValueObject.js'

export class SellerValueObject extends ValueObject {
  #contractId
  #isProfessional
  #name
  #pack
  #phone
  #ratings

  constructor({contractId, isProfessional, name, pack, phone, ratings}) {
    super()
    this.#contractId = contractId
    this.#isProfessional = isProfessional
    this.#name = name
    this.#pack = pack
    this.#phone = phone
    this.#ratings = ratings
  }

  static createFromListingApi({seller, phone}) {
    return new SellerValueObject({
      contractId: seller.contractId,
      isProfessional: seller.isProfessional,
      name: seller.name,
      pack: PackSellerValueObject.createFromListingApi({pack: seller.pack || {}}),
      phone,
      ratings: DealerProfileRatingsValueObject.createFromListingApi({ratings: seller.ratings || {}})
    })
  }

  get contractId() {
    return this.#contractId
  }

  get hasPack() {
    return this.#pack.hasPack
  }

  get hasRatings() {
    return this.#ratings.hasRatings
  }

  get isProfessional() {
    return this.#isProfessional
  }

  get name() {
    return this.#name
  }

  get pack() {
    return this.#pack.value
  }

  get phone() {
    return this.#phone
  }

  get ratings() {
    return this.#ratings.value
  }

  get value() {
    return {
      contractId: this.#contractId,
      hasPack: this.hasPack,
      hasRatings: this.hasRatings,
      isProfessional: this.#isProfessional,
      name: this.#name,
      pack: this.#pack.value,
      phone: this.#phone,
      ratings: this.#ratings.value
    }
  }
}
